import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PlusIcon from "@material-ui/icons/Add";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Paper,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";

const headRows = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Ad",
  },
  {
    id: "deviceModel",
    numeric: false,
    disablePadding: false,
    label: "Qurğu modeli",
  },

  {
    id: "tools",
    numeric: false,
    disablePadding: true,
    label: "Əməliyyatlar",
  },
];

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,

  } = props;

  return (
    <TableHead>
      <TableRow>
       
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            sortDirection={orderBy === row.id ? false : false}
          >
            <TableSortLabel   active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" ? onRequestSort(row.id) : null;
              }}>
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: "flex-end",
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  dense: {
    margin: theme.spacing(2),
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected,  setShowCreate,permissionList } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.actions}>
      { permissionList.some(element => element === "create_device_type") && 

        <Tooltip title="Əlavə et" placement="top">
          <button
            className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle flex-shrink-0"
            onClick={() => setShowCreate(true)}
          >
            <PlusIcon />
          </button>
        </Tooltip>
     } 
      </div>
    </Toolbar>
  );
};


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
}));

export default function EnhancedTable({
  deviceTypes,
  isLoading,
  setText,
  setChooseDeviceTypeId,
  setShowCreate,
  setShowRemove,
  setShowRemoveDeviceTypes,
  setShowEdit,
  deleteDeviceTypesIds,
  setDeleteDeviceTypesIds,
  setSortField,
    setOrderByTable,
    sortField,
    orderBy,
    updateSkip,
    updateTake,
    count,
    filterInputsUpdate,
    filterInputs,
    isError,

}) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const permissionList= useSelector(state => state.auth.permissionList)

  function handleRequestSort(property) {
  // const isDesc = sortField === property && !orderBy;
  const isDesc = sortField === property && orderBy === 'desc';


  // setOrderByTable(isDesc);
  setOrderByTable(isDesc ? 'asc' : 'desc');
    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = deviceTypes.map((n) => n.id);
      setDeleteDeviceTypesIds(newSelecteds);
      return;
    }
    setDeleteDeviceTypesIds([]);
  }

 
  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }

  const isSelected = (id) => deleteDeviceTypesIds.indexOf(id) !== -1;

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
      {isLoading && (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      )}
        <EnhancedTableToolbar
          numSelected={deleteDeviceTypesIds.length}
          setShowCreate={setShowCreate}
          setShowRemoveDeviceTypes={setShowRemoveDeviceTypes}
          filterInputsUpdate={filterInputsUpdate}
          filterInputs={filterInputs}
          permissionList={permissionList}
        />
      
        <div className={classes.tableWrapper}>
        {deviceTypes.length ? (
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              numSelected={deleteDeviceTypesIds.length}
              onSelectAllClick={handleSelectAllClick}
              rowCount={deviceTypes.length}
              order={orderBy}
              orderBy={sortField}
              onRequestSort={handleRequestSort}

            />
            <TableBody>
              {deviceTypes.map((row, index) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                  >
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                    >
                      {row.name ? row.name: "-"}
                    </TableCell>
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                    >
                      {row.deviceModel.name ? row.deviceModel.name: "-"}
                    </TableCell>
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                    >
                    { permissionList.some(element => element === "edit_device_type") && 
                      <Tooltip title="Düzəliş et" placement="top">
                        <button
                          aria-label="edit"
                          className="btn btn-sm btn-icon btn-bg-light btn-text-dark btn-hover-dark mr-2"
                          onClick={() => {
                            setChooseDeviceTypeId(row.id);
                            setShowEdit(true);
                          }}
                        >
                          <EditIcon />
                        </button>
                      </Tooltip>
                     } 
                      { permissionList.some(element => element === "delete_device_type") && 

                      <Tooltip title="Sil" placement="top">
                        <button
                          aria-label="Delete"
                          className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger  mr-2"
                          onClick={() => {
                            setChooseDeviceTypeId(row.id);
                            setShowRemove(true);
                          }}
                        >
                          <DeleteIcon />
                        </button>
                      </Tooltip>}
                      
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          ) : !deviceTypes.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}

        </div>
 {count > 10 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25,50]}
          component="div"
           count={count}
           labelRowsPerPage={"Sətirlərin sayı"}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "Əvvəlki səhifə",
          }}
          nextIconButtonProps={{
            "aria-label": "Növbəti səhifə",
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        /> )}  
      </Paper>
    </div>
  );
}
